<template>
  <v-dialog v-model="dialog" :persistent="loading" max-width="500">
    <v-card tile :disabled="loading">
      <v-card-text>
        <div class="pa-10">
          <h3>MEUS DADOS</h3>

          <div class="text-center mt-5">
            <v-form ref="form" @submit.prevent="atualizar()">
              <v-text-field
                v-model="form.nome"
                label="Nome"
                type="text"
                color="teal"
                prepend-icon="mdi-account-circle"
                class="mt-2"
                :rules="[rules.required]"
              />
              <v-text-field
                v-model="form.apelido"
                label="Como gostaria de ser chamado"
                type="text"
                color="teal"
                prepend-icon="mdi-account-circle"
                class="mt-2"
                :rules="[rules.required]"
              />
              <v-text-field
                v-model="form.telefone"
                label="Contato"
                type="text"
                color="teal"
                hint="Informe seu contato do Whatsapp"
                persistent-hint
                prepend-icon="mdi-whatsapp"
                v-mask="'(##)#####-####'"
                class="mt-2"
                :rules="[rules.required]"
              />
              <v-text-field
                :value="email"
                label="Email"
                type="text"
                color="teal"
                prepend-icon="mdi-email"
                class="mt-2"
                :disabled="true"
              />
              <v-text-field
                :value="cpf"
                label="CPF"
                type="text"
                color="teal"
                prepend-icon="mdi-text-box"
                v-mask="'###.###.###-##'"
                class="mt-2"
                :disabled="true"
              />
              <div class="mt-7">
                <v-btn
                  color="teal"
                  tile
                  dark
                  class="mr-1"
                  :loading="loading"
                  type="submit"
                >
                  <v-icon left>mdi-content-save</v-icon>
                  Salvar
                </v-btn>

                <v-btn
                  tile
                  text
                  color="grey darken-1"
                  class="mr-1"
                  type="button"
                  @click="show(false)"
                >
                  Cancelar
                </v-btn>
              </div>
            </v-form>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import rules from '@/utils/rules'
import Auth from '@/services/auth'

export default {
  name: 'DialogAtualizarDados',

  data() {
    return {
      dialog: false,
      loading: false,
      rules: rules,

      form: {
        nome: '',
        apelido: '',
        telefone: ''
      },

      email: '',
      cpf: ''
    }
  },

  computed: {
    ...mapGetters('auth', ['getUser'])
  },

  methods: {
    show(show = true) {
      this.dialog = show
    },

    async atualizar() {
      if(!this.$refs.form.validate()) return

      this.loading = true
      try{
        let response = await new Auth().updateAccount(this.cpf, { ...this.form })
        this.$swal.success('', response)
      }catch(error){
        console.error(error)
        this.$swal.error(error)
      }finally{
        this.loading = false
      }
    }
  },

  mounted() {
    this.form.nome = this.getUser.nome
    this.form.apelido = this.getUser.apelido
    this.form.telefone = this.getUser.telefone
    this.email = this.getUser.email
    this.cpf = this.getUser.cpf
  }
}
</script>
